import sharedoCapabilities from "@/services/sharedo/sharedoCapabilitiesService";

export default {
    computed: {
        capabilities: function () {
            return sharedoCapabilities.get();
        }
    }
}
